"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JOB_TERM;
(function (JOB_TERM) {
    JOB_TERM["ONE_TIME"] = "one_time";
    JOB_TERM["LONG_TERM"] = "long_term";
    JOB_TERM["FULL_TIME"] = "full_time";
})(JOB_TERM = exports.JOB_TERM || (exports.JOB_TERM = {}));
var TIME_PERIOD;
(function (TIME_PERIOD) {
    TIME_PERIOD["DEFINITE"] = "definite";
    TIME_PERIOD["INDEFINITE"] = "indefinite";
})(TIME_PERIOD = exports.TIME_PERIOD || (exports.TIME_PERIOD = {}));
var TIME_FLEXIBILITY;
(function (TIME_FLEXIBILITY) {
    TIME_FLEXIBILITY["FLEXIBLE"] = "flexible";
    TIME_FLEXIBILITY["FIXED"] = "fixed";
})(TIME_FLEXIBILITY = exports.TIME_FLEXIBILITY || (exports.TIME_FLEXIBILITY = {}));
//# sourceMappingURL=enums.js.map